import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import * as types from "../../constants/ComponentConstants";

const Tooltip = (props) => {
	let tooltipWrapperClassName;
	let tooltipTriggerClassName;
	let tooltipClassName;
	let tooltipContentClassName;

	const {
		windowAlignRight,
		icon,
		isInput,
		tooltipType,
		tooltipColor,
		iconColor,
		isSecundaryTooltip,
		windowWidth,
		text,
		className,
		borderClassName
	} = props;

	const iconClassName = icon ? icon : types.TOOLTIP_ICON_INFO;
	const _windowAlignRight = windowAlignRight === undefined ? false : windowAlignRight;

	tooltipWrapperClassName = {
		"c-input__tooltip__wrapper": isInput,
		"c-tooltip": !isInput,
		"green": ((tooltipType == types.TOOLTIP_INFO || !tooltipType) && !tooltipColor),
		"orange": (tooltipType == types.TOOLTIP_WARNING && !tooltipColor),
		"red": (tooltipType == types.TOOLTIP_ERROR && !tooltipColor),
		[tooltipColor]: tooltipColor
	};

	tooltipTriggerClassName = {
		"fa": true,
		"fa-fw": true,
		[iconClassName]: iconClassName,
		"c-input__tooltip__trigger": isInput,
		"c-tooltip__trigger": !isInput,
		[iconColor]: iconColor,
		[className]: className
	};

	tooltipClassName = {
		"c-input__tooltip__window": isInput,
		"c-tooltip__window": !isInput,
		"align-right": windowAlignRight,
		"secundary": isSecundaryTooltip,
		[borderClassName]: borderClassName
	};
	tooltipContentClassName = {
		"c-input__tooltip__content": isInput,
		"c-tooltip__content": !isInput
	};

	let triggerStyle = {
		fontSize: '1rem',
		color: iconColor
	};

	if (isSecundaryTooltip && isInput) {
		triggerStyle.right = '35px';
	}

	// positioneer window over icon
	let windowStyle = {};
	if (!isInput && !_windowAlignRight) {
		windowStyle.left = '-12px';
		windowStyle.marginLeft = '0px';
	}
	if (windowWidth) {
		windowStyle.width = windowWidth + 'em';
	}

	return (
		text ?
			<span className={classnames(tooltipWrapperClassName)}>
				<i key="tooltipTrigger" className={classnames(tooltipTriggerClassName)} style={triggerStyle} />
				<span key="tooltip" className={classnames(tooltipClassName)} style={windowStyle}>
					<span className={classnames(tooltipContentClassName)} dangerouslySetInnerHTML={{ __html: text }}></span>
				</span>
			</span> : null
	);
};

Tooltip.propTypes = {
	text: PropTypes.string.isRequired,
	tooltipType: PropTypes.string.isRequired,
	tooltipColor: PropTypes.string,
	isSecundaryTooltip: PropTypes.bool,
	windowWidth: PropTypes.number,
	icon: PropTypes.string,
	iconColor: PropTypes.string,
	isInput: PropTypes.bool,
	windowAlignRight: PropTypes.bool,
	className: PropTypes.string,
	borderClassName: PropTypes.string
};

Tooltip.defaultProps = {
	windowAlignRight: true
};

export default Tooltip;
